import React, {Component, Fragment} from 'react'
import FormGroup from './FormGroup'
import Label from './Label'
import Input from './Input'


class RenderInputFormGroup extends Component {
    render() {
        return (
            <FormGroup {...this.props}>
                {
                    this.renderLabelInput()
                }
            </FormGroup>
        )
    }

    renderLabelInput = () => {
        let {label, type} = this.props

        return (
            <Fragment>
                {label && <Label {...this.props}>
                    {
                        type === 'checkbox' && <Input {...this.props} />
                    }{label}
                </Label>}
                {
                    type !== 'checkbox' && <Input {...this.props} />
                }
            </Fragment>
        )
    }
}

export default RenderInputFormGroup


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/RenderInputFormGroup.js